// ----------------------------------------------------------------------------
// Helper: Useful helpers
// ----------------------------------------------------------------------------

/**
 * Accessibility Helper - Toggle Inner Focus
 */
export function toggleInnerFocus(slider, focusableElements) {
  focusableElements.forEach(fosusableElement => {
    slider.slides.forEach((slide, index) => {
      if (index === slider.activeIndex) {
        if (fosusableElement === '.plyr') {
          var _slide$querySelector;
          (_slide$querySelector = slide.querySelector(fosusableElement)) === null || _slide$querySelector === void 0 || _slide$querySelector.setAttribute('tabindex', '0');
        } else {
          slide.querySelectorAll(fosusableElement).forEach(elem => {
            elem === null || elem === void 0 || elem.removeAttribute('tabindex');
          });
        }
      } else {
        slide.querySelectorAll(fosusableElement).forEach(elem => {
          elem === null || elem === void 0 || elem.setAttribute('tabindex', '-1');
        });
      }
    });
  });
}

/**
 * iamClass to Name
 * @param {string} classOrTagName - The class or tag name
 * @returns {string} - The class name without the 'iam' prefix and first letter lowercase
 * e.g. iamAddToCartButton     -> 'addToCartButton'
 * e.g. iam-add-to-cart-button -> 'addToCartButton'
 */
export function componentToName(classOrTagName) {
  if (!classOrTagName) return 'unknown';
  return classOrTagName.replace(/^iam[-]?/i, '') // Remove 'iam' or 'iam-' prefix
  .replace(/^[A-Z]+(-[A-Z]+)*$/, match => match.toLowerCase()) // Ensure string is lower case if it's kebab-case
  .replace(/-([a-zA-Z])/g, (_, letter) => letter.toUpperCase()) // Convert kebab-case to camelCase
  .replace(/^([A-Z])/, match => match.toLowerCase()) // Ensure first letter is lowercase
;
}